<script setup>
  import { ref, defineAsyncComponent, computed } from 'vue'
  import { text } from '@/plugins/utils'

  import { useRoute, useRouter } from 'vue-router'
  const router = useRouter()
  const route = useRoute()

  const BaseLoader = defineAsyncComponent (() =>
      import(/* webpackChunkName: "components/base/BaseLoader" */ '@/components/base/BaseLoader.vue')
  );
  const BaseButton = defineAsyncComponent(() =>
      import(/* webpackChunkName: "BaseButton" */ '@/components/base/buttons/BaseButton.vue')
  )
  const InProcessBody = defineAsyncComponent(() =>
      import(/* webpackChunkName: "InProcessBody" */ '@/views/cards/CardPage/Verification/statusBodies/InProcessBody.vue')
  )
  const FailedBody = defineAsyncComponent(() =>
      import(/* webpackChunkName: "FailedBody" */ '@/views/cards/CardPage/Verification/statusBodies/FailedBody.vue')
  )
  const DeclinedBody = defineAsyncComponent(() =>
      import(/* webpackChunkName: "DeclinedBody" */ '@/views/cards/CardPage/Verification/statusBodies/DeclinedBody.vue')
  )
  const ApprovedBody = defineAsyncComponent(() =>
      import(/* webpackChunkName: "ApprovedBody" */ '@/views/cards/CardPage/Verification/statusBodies/ApprovedBody.vue')
  )
  const CreatedBody = defineAsyncComponent(() =>
      import(/* webpackChunkName: "CreatedBody" */ '@/views/cards/CardPage/Verification/statusBodies/CreatedBody.vue')
  )
  const LowBalanceBody = defineAsyncComponent(() =>
      import(/* webpackChunkName: "LowBalanceBody" */ '@/views/cards/CardPage/Verification/statusBodies/LowBalanceBody.vue')
  )

  const verificationState = ref({})
  const loading = ref(true)

  const inProcessStatus = computed(() => {
    return verificationState.value.status === 'in_process'
  })
  const failedStatus = computed(() => {
    return verificationState.value.status === 'failed'
  })
  const declinedStatus = computed(() => {
    return verificationState.value.status === 'declined'
  })
  const approvedStatus = computed(() => {
    return verificationState.value.status === 'approved'
  })
  const createdStatus = computed(() => {
    return verificationState.value.status === 'created'
  })
  const lowBalanceStatus = computed(() => {
    return verificationState.value.status === 'low_balance'
  })

  const actionBtnText = computed(() => {
    if (failedStatus.value) {
      return text('verification_card_page.actions.refresh')
    } else if (approvedStatus.value) {
      return text('verification_card_page.actions.confirm')
    } else if (createdStatus.value) {
      return text('verification_card_page.actions.to_card')
    } else {
      return text('verification_card_page.actions.to_up')
    }
  })

  const close =()=> {
    router.back()
  }

  const getRandomStatus = () => {
    const arr = ['in_process', 'declined', 'failed', 'approved']

    if (!Array.isArray(arr) || arr.length === 0) {
      console.warn("Функция getRandomArrayElement ожидает непустой массив.");
      return undefined; // Или null, или можно выбросить ошибку
    }
    const randomIndex = Math.floor(Math.random() * arr.length);
    return arr[randomIndex];
  };

  async function getVerificationState() {
    return new Promise(resolve => {
      setTimeout(() => {
        verificationState.value = {
          status: getRandomStatus(),
          // status: 'approved',
        }
        loading.value = false
        resolve()
      }, 500)
    })
  }

  getVerificationState()

  function stepForward() {
    if (failedStatus.value) {
      router.push({ name: 'NewCardPage', params: { id: route.params.id } })
    } else if (approvedStatus.value) {
      verificationState.value.status = Math.random() < 0.5 ? 'created' : 'low_balance'
    } else if (createdStatus.value) {
      router.push({ name: 'CardPage', params: { id: route.params.id } })
    } else {
      router.push({ name: 'WalletTopUp' })
    }
  }
</script>

<template>
  <div class="verification_card-page__wrapper">
    <BaseLoader v-if="loading" style="margin: 20px 0" />
    <template v-else>
      <div class="body">
        <InProcessBody v-if="inProcessStatus" />
        <FailedBody v-if="failedStatus" />
        <DeclinedBody v-if="declinedStatus" />
        <ApprovedBody v-if="approvedStatus" />
        <CreatedBody v-if="createdStatus" />
        <LowBalanceBody v-if="lowBalanceStatus" />
      </div>
      <div class="actions">
        <BaseButton v-if="!inProcessStatus && !declinedStatus" @click="stepForward">
          <template #label>
            {{ actionBtnText }}
          </template>
        </BaseButton>
        <BaseButton
          grayscale
          @click="close"
        >
          <template #label>
            {{ text('verification_card_page.actions.close') }}
          </template>
        </BaseButton>
      </div>
    </template>

  </div>
</template>

<style lang="scss" scoped>
  .verification_card-page__wrapper {
    height: calc(100dvh - 230px);
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    gap: 12px;

    padding: 24px;

    .body {
      height: 100%;
    }
    .actions {
      display: flex;
      gap: 12px;
    }

    @media (max-width: 920px) {
      .actions {
        flex-direction: column;
      }
    }
  }
</style>